<div class="login-container">
    <!--Banner starts here-->
    <section id="banner" class="banner">
      <div class="container">
        <div class="banner__logos">
          <div>
            <img
              src="../../assets/images/ust_logowhite.png"
              class="banner__logosz"
              alt="ust-logo"
            /> 
          </div>
          <div class="banner__logolabel"> - Licensing App</div>
        </div>
        <div class="banner__main">
          <div class="banner__mainlabel">Sign In</div>
          <form
            *ngIf="!isLoggedIn"
            name="form"
            (ngSubmit)="f.form.valid && onSubmit()"
            #f="ngForm"
            novalidate
          >
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text inputgrouptext--custom"><i class="fa fa-user" aria-hidden="true"></i></span>
              </div>
              <input
              type="text"
              class="form-control banner__iputpad"
              name="username"
              [(ngModel)]="form.username"
              required
              #username="ngModel"
              placeholder="Username"
              [ngClass]="{'is-invalid': username.errors && f.submitted }"
            />

            </div>
            <div
            class="error-block"
            role="alert"
            *ngIf="username.errors && f.submitted"
          >
            <span class="text-danger">Username is required!</span>
          </div>
           <div class="mb-4"></div>


          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text inputgrouptext--custom"><i class="fa fa-lock" aria-hidden="true"></i></span>
            </div>
              <input
                type="password"
                class="form-control banner__iputpad"
                name="password"
                [(ngModel)]="form.password"
                required
                maxlength="32"
                #password="ngModel"
                placeholder="Password"
                [ngClass]="{'is-invalid': password.errors && f.submitted }"
              />

            </div>
            <div
            class="error-block"
            role="alert"
            *ngIf="password.errors && f.submitted">
            <span class="text-danger">Password is required!</span>
          </div>
          <div class="banner__check">
            <div><a href="/forgotusername" [hidden]="true" class="link-text">Forgot Username?</a></div>
            <div><a routerLink="/forgot-password" class="link-text">Forgot Password?</a></div>
          </div>
          <div class="mb-4"></div>
            <button type="submit" class="banner__btncustom">Sign In</button>

            <div class="form-group">
              <div
                class="error-block"
                role="alert"
                *ngIf="f.submitted && isLoginFailed"
              >
                <span class="text-danger">{{ errorMessage }}</span>
              </div>
            </div>
          </form>
          <div class="banner__signup">
            <div>
              Don't have an account?&nbsp;&nbsp;<a href="/register" class="link-text"
                >Sign Up</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
